import { _, $, Backbone, moment } from "../../../vendor";
import { Backform, Notification } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import Appointment from "../../models/Appointment";

// @todo As backform.js saves values immediately (= without pushing "submit"),
// this behaviour has to be re-thought for all backform-inheriting forms

export default InboomaBaseView.extend({
  template: _.noop,
  el: "#inb-modal-reschedule",

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    this.$el.find(".reschedule-title").html(this.model.get("name"));
    this.$el.find(".reschedule-start").html(moment(this.model.get("begin")).format("D MMMM YYYY"));

    this.getUI("errorMessageField").addClass("hide");

    const that = this,
      fields = [
        {
          name: "begin",
          label: this.t("start", null, "capital"),
          required: true,
          allowOnlyTime: true,
          control: "datetimepicker",
          size: {
            large: "6",
          },
        },
        {
          name: "end",
          label: this.t("end", null, "capital"),
          allowOnlyTime: true,
          control: "datetimepicker",
          size: {
            large: "6",
          },
        },
        {
          name: "max_pers_count",
          label: this.t("max_pers_count", null, "capital"),
          control: "input",
          type: "number",
          size: {
            large: "6",
          },
          extraAttributes: [
            'min="' +
              (that.model.get("max_pers_count") - that.model.get("current_available_pers_count")) +
              '"',
          ],
          helpMessage: this.t("max_pers_count_help"),
        },
        {
          label: this.t("reschedule"),
          control: "button",
          extraClasses: ["expanded button-submit"],
        },
        {
          // Not visible as it does not only set back time but
          // destroys the whole appointment...
          name: "remove-appointment",
          control: "uneditable-input",
          visible: false, // model => (model.get('id') != ''),
          extraTopClasses: ["fake-link text-right"],
          label: this.t("unset_reschedule"),
          size: {
            small: "12",
          },
        },
      ];

    that.rescheduleModal = new Foundation.Reveal(this.$el);

    const form = new Backform.Form({
      el: that.$el.find(".inb-event-reschedule-form__content"),
      model: that.model,
      fields: fields,

      events: {
        submit: function () {
          return false;
        },

        "click .remove-appointment": (ev) => {
          ev.preventDefault();

          if (confirm(this.t("really_remove"))) {
            that.model.destroy({
              success(model, repsonse) {
                new Notification({
                  message: that.t("success_removed_rescheduling"),
                  duration: 5000,
                  closeable: true,
                  icon: "fi fi-trash",
                });

                that.rescheduleModal.close();
                window.location.reload();
              },
              error() {
                new Notification({
                  message: that.t("request_error"),
                  duration: 5000,
                  type: "warning",
                  closeable: true,
                  icon: "fi fi-x",
                });
              },
            });
          }
        },

        "click .button-submit": function (ev) {
          ev.preventDefault();
          that.$el.find("form .is-invalid-input").removeClass("is-invalid-input");

          $(that.$el.find("form")).foundation("validateForm");

          if (
            typeof that.model != "undefined" &&
            that.model.isValid() &&
            !that.$el.find("form .is-invalid-input").length
          ) {
            that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);
            console.log("reschedule: collection & this.model", that.collection, that.model);

            that.model.save(null, {
              success: (model, response) => {
                model = new Appointment(model.toJSON());

                that.collection.set(model, { add: true, merge: true, remove: false });
                that.trigger("updated");
                that.rescheduleModal.close();

                new Notification({
                  message: that.t("success_saved_rescheduling", null, "capital"),
                  duration: 5000,
                  type: "success",
                  closeable: true,
                  icon: "fi fi-marker",
                });

                window.location.reload();
              },
              error: (model, response, options) => {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("request_error"))
                  .fadeIn("fast");
              },
            });
          } else {
            if (typeof that.model != "undefined") {
              that
                .getUI("errorMessageField")
                .removeClass("hide")
                .html(that.t("form_validation_error"))
                .fadeIn("fast");
            }
          }
        },
      },
    }).render();

    new Foundation.Abide(that.$el.find("form"), { liveValidate: true });

    that.rescheduleModal.open();

    $(document).on("closed.zf.reveal", () => {
      Backbone.history.navigate("appointments/" + that.options.active_calendar_id, {
        trigger: true,
      });
      //that.remove();
      //that.destroy();
      that.unbind();
      delete that.model;
      $(document).off("closed.zf.reveal");
    });
  },
});
